export default "__VITE_ASSET__tndLEWN2__"